import {
  TicketGroupAvailabilityBehavior,
  TicketTypeAvailabilityBehavior,
} from '@/dashboard/enums/tickets';
import { formatDateForInput } from '@/dashboard/services/formatting/date';

export default function handleAvailabilityBehaviorOnChange({
  value,
  triggerKey,
  setFieldValue,
  page,
  values,
  getSaleStartOnFromReference,
}) {
  switch (value) {
    case TicketTypeAvailabilityBehavior.ALWAYS_AVAILABLE:
    case TicketGroupAvailabilityBehavior.ALWAYS_AVAILABLE: {
      setFieldValue('saleStartOn', '');
      setFieldValue('saleEndOn', '');
      setFieldValue(triggerKey, '');
      break;
    }
    case TicketTypeAvailabilityBehavior.UNTIL_EVENT_STARTS:
    case TicketGroupAvailabilityBehavior.UNTIL_EVENT_STARTS: {
      setFieldValue('saleStartOn', '');
      if (page.eventDetails?.startDate != null && page.eventDetails?.timezone != null) {
        setFieldValue(
          'saleEndOn',
          formatDateForInput(page.eventDetails?.startDate, page.eventDetails?.timezone),
        );
      }
      setFieldValue(triggerKey, '');
      break;
    }
    case TicketTypeAvailabilityBehavior.DATE_TIME_BASED:
    case TicketGroupAvailabilityBehavior.DATE_TIME_BASED: {
      setFieldValue('saleStartOn', '');
      setFieldValue(triggerKey, '');
      if (
        (values.saleEndOn == null || values.saleEndOn == '') &&
        page.eventDetails?.startDate != null &&
        page.eventDetails?.timezone != null
      ) {
        setFieldValue(
          'saleEndOn',
          formatDateForInput(page.eventDetails?.startDate, page.eventDetails?.timezone),
        );
      }
      break;
    }
    case TicketTypeAvailabilityBehavior.AFTER_TICKET_SALE_ENDS:
    case TicketGroupAvailabilityBehavior.AFTER_TICKET_SALE_ENDS:
    case TicketTypeAvailabilityBehavior.AFTER_TICKET_SOLD_OUT:
    case TicketGroupAvailabilityBehavior.AFTER_TICKET_SOLD_OUT:
    case TicketTypeAvailabilityBehavior.AFTER_TICKET_ENDS_OR_SOLD_OUT:
    case TicketGroupAvailabilityBehavior.AFTER_TICKET_ENDS_OR_SOLD_OUT: {
      if (values[triggerKey] == null || values[triggerKey] === '') {
        setFieldValue('saleStartOn', '');
      } else {
        const saleStartOn = getSaleStartOnFromReference(values[triggerKey]);
        if (saleStartOn) {
          setFieldValue('saleStartOn', saleStartOn);
        }
      }
      if (
        (values.saleEndOn == null || values.saleEndOn == '') &&
        page.eventDetails?.startDate != null &&
        page.eventDetails?.timezone != null
      ) {
        setFieldValue(
          'saleEndOn',
          formatDateForInput(page.eventDetails?.startDate, page.eventDetails?.timezone),
        );
      }
      break;
    }
  }

  setFieldValue('availabilityBehavior', value);
}
